<template>
    <div class="write page-color"  :class="'level' + currentLevel">
        <header-back :definition="definition"></header-back>

        <div class="container">

            <h3 class="level-header"> LEVEL {{currentLevel}}
                <p> {{total - copyVerbs.length}} / {{total}} </p>
            </h3>

            <div class="container-selection" v-if="copyVerbs.length > 0">
                <selection-card :class="{disabled: tryAgain}" :selected="selectedTense" :verb="verb"></selection-card>
                <button class="accept" :class="{disabled: !acceptButton}" @click="compareVerbs()">➜</button>
                <button class="correct" :class="{disabled: !correct}" @click="clear()">✔</button>
            </div>

            <div v-else class="endGame">
                CONGRATULATIONS
                <button @click="startAgain()">
                    Try Again
                    <span>↻</span>
                </button>
            </div>

            <div class="container-options">
                <div class="icon" v-if="!tryAgain">
                    <img src="../assets/images/keyboard.svg" alt="keyboard">
                </div>
                <transition name="fade">
                    <div v-if="tryAgain" class="correction">
                        <div>
                            <h4>Correct Answer</h4>
                            <p>
                                <span>{{selected.infinitive}}</span>
                                <span>{{selected.simplePast}}</span>
                                <span>{{selected.pastParticiple}}</span>
                            </p>
                        </div>
                        <button @click="clear()">
                            Try Again
                            <span>↻</span>
                        </button>
                    </div>

                    <div v-if="correct" class="correction correct">
                        <div>
                            <h2>Well Done</h2>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import headerBack from '../components/Header';
    import irregularVerbsData from '../data/irregularVerbs';
    import selectionCard from '../components/SelectionCard';

    export default {
        data() {
            return {
                irregularVerbs: irregularVerbsData.IrregularVerbs,
                definition: null,
                copyVerbs: [],
                selected: null,
                verb: {
                    infinitive: "",
                    simplePast: "",
                    pastParticiple: ""
                },
                tryAgain: false,
                correct: false,
                selectedTense: null,
                currentLevel: this.$route.params.id,
                total: 0
            }
        },
        components: {
            headerBack,
            selectionCard
        },
        created() {
            //this.copyVerbs = this.irregularVerbs.slice(0);
            let vm = this;
            this.copyVerbs = this.irregularVerbs.filter(function(value) {
                return value.level === vm.currentLevel;
            });
            this.total = this.copyVerbs.length;
            this.selectNewVerb();
        },
        methods: {
            clear() {
                this.verb = {
                    infinitive: "",
                    simplePast: "",
                    pastParticiple: ""
                };

                this.tryAgain = false;
                this.correct = false;
                this.total = this.copyVerbs.length;
            },
            selectNewVerb(){
                this.getPosition();
            },
            getPosition(){
                this.clear();
                this.position = Math.floor(Math.random() * this.copyVerbs.length);
                this.selected = this.copyVerbs[this.position];
                let randomTense = Math.floor(Math.random() * 3);
                switch (randomTense) {
                    case 0:
                        this.selectedTense = this.selected.infinitive;
                        break;
                    case 1:
                        this.selectedTense = this.selected.simplePast;
                        break;
                    case 2:
                        this.selectedTense = this.selected.pastParticiple;
                        break;
                    default:
                        this.selectedTense = this.selected.infinitive;
                        break;
                }

                this.definition = this.selected.definition;
            },
            compareVerbs(){

                let verbInfinitive = this.verb.infinitive.replace(/ /g,'');
                let verbSimplePast = this.verb.simplePast.replace(/ /g,'');
                let verbPastParticiple = this.verb.pastParticiple.replace(/ /g,'');

                if (this.selected.infinitive.toLowerCase() === verbInfinitive.toLowerCase()
                    && this.selected.simplePast.toLowerCase() === verbSimplePast.toLowerCase()
                    && this.selected.pastParticiple.toLowerCase() === verbPastParticiple.toLowerCase()){

                    this.copyVerbs.splice(this.position, 1);
                    this.correct = true;

                    let self = this;
                    setTimeout(function(){
                        self.selectNewVerb();
                    }, 600);

                } else {
                    this.tryAgain = true;
                }
            },
            startAgain(){

            }
        },
        computed: {
            acceptButton() {
                return this.verb.infinitive !== "" && this.verb.simplePast !== "" && this.verb.pastParticiple !== "";
            }
        }
    }
</script>